import { z } from "zod";
export const NicknameSchema = z
    .string()
    .min(1)
    .max(24)
    .transform((s) => s.trim().replace(/\s+/g, " "))
    .refine((s) => s.length >= 1, "Nickname cannot be empty after trimming");
export const JoinRequestSchema = z.object({
    pin: z.string().regex(/^\d{6}$/, "PIN must be exactly 6 digits"),
    nickname: NicknameSchema,
});
export const JoinResponseSchema = z.object({
    sessionId: z.string().uuid(),
    playerId: z.string().uuid(),
    playerToken: z.string().min(1),
    nickname: z.string(),
});
//# sourceMappingURL=session.js.map